import antdData from 'antd/locale/ro_RO'

const messages = {
  'topBar.profileMenu.hello': 'Salut',
  'topBar.profileMenu.role': 'Rol(uri)',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Telefon',
  'topBar.profileMenu.refresh': 'Reîncarcă',
  'topBar.profileMenu.logout': 'Ieșire',

  'datatable.search': 'Căutare...',
  'datatable.actions.refresh': 'Reîncărcare',
  'datatable.tooltips.clear': 'Resetează toate filtrele',
  'datatable.tooltips.refresh': 'Reîncarcă utilizând filtrele curente',
  'datatable.tooltips.columns': 'Afișează / ascunde coloane',
  'datatable.tooltips.export': 'Exportă',

  // business specific below
  'createOrder.menu.title': 'Comanda noua',
  'createOrder.menu.title.fast': 'Comanda noua rapida',
  'createOrder.car_class': 'Clasa',
  'createOrder.phone': 'Telefon',
  'createOrder.name': 'Nume',
  'createOrder.obs': 'Obs',
  'createOrder.street_no': 'Nr',
  'createOrder.block': 'Bloc',
  'createOrder.entrance': 'Scara',
  'createOrder.pickup': 'Adresa',
  'createOrder.dropoff': 'Destinatie',
  'createOrder.send': 'Trimite',
  'createOrder.send_scheduled': 'Trimite precomanda',
  'createOrder.cancel': 'Anulare',
  'createOrder.employee': 'Angajat',
  'dashboard.menu.title': 'Comenzi',
  'dashboard.recent_trips': 'Călătorii recente',
  'dashboard.create_account.message': 'Nu ai creat încă niciun cont de companie, așa că poți înregistra unul chiar acum!',
  'dashboard.create_account.action': 'Cont nou companie',
  'common.trips_list.filters.all_people': 'Toți angajații',
  'common.trips_list.filters.select_people': 'Selecteaza angajatul',
  'common.trips_list.columns.date_time': 'Data & Ora',
  'common.trips_list.columns.person': 'Angajat',
  'common.trips_list.columns.pickup': 'Preluare',
  'common.trips_list.columns.dropoff': 'Destinație',
  'common.trips_list.columns.cost': 'Cost',
  'common.trips_list.columns.comment': 'Comentariu',
  'common.trip_details.pickup': 'Preluare',
  'common.trip_details.dropoff': 'Destinație',
  'common.trip_details.pass': 'Intermediar',
  'common.trip_details.driver': 'Șofer',
  'common.trip_details.car': 'Mașină',
  'common.trip_details.class': 'Clasă',
  'common.trip_details.duration': 'Durată',
  'common.trip_details.download_receipt': 'Descarcă factura',
  'common.trip_details.code': 'Indicativ',
  'common.notifications.done': 'Realizat!',
  'upcomings.menu.title': 'Precomenzi',
  'upcomings.upcoming_trips': 'Precomenzi',
  'upcomings.create_upcoming.message': 'Nu ai creat încă nici o precomanda, așa că poți crea una chiar acum!',
  'upcomings.create_upcoming.action': 'Precomanda noua',
  'upcomings.import.action': 'Import precomenzi',
  'upcomings.import.uploading': 'Se incarca fisierul ...',
  'upcomings.import.success': 'Fisierul a fost importat',
  'upcomings.import.error': 'eroare',
  'upcomings.import_ex.action': 'Exemplu import',
  'people.menu.title': 'Angajați',
  'people.trip_history': 'Istoric călătorii',
  'people.actions.add': 'Adaugă angajat',
  'people.actions.view': 'Vizualizează',
  'people.actions.remove': 'Elimină',
  'people.actions.save': 'Salvează',
  'people.actions.edit': 'Editează',
  'people.columns.name': 'Nume',
  'people.columns.first_name': 'Prenume',
  'people.columns.last_name': 'Nume',
  'people.columns.job': 'Poziție',
  'people.columns.phone': 'Telefon',
  'people.columns.labels': 'Etichete',
  'people.columns.status': 'Status',
  'people.columns.actions': 'Acțiuni',
  'people.placeholders.first_name': 'Prenume (ex. Ion)',
  'people.placeholders.last_name': 'Nume (ex. Ursu)',
  'people.placeholders.job': 'Ex. Director',
  'people.placeholders.phone': 'Ex. +37365656565',
  'people.placeholders.labels': 'Ex. Manageri, Contabilitate',
  'people.placeholders.status': 'Selectează status',
  'people.placeholders.status.actve': 'activ',
  'people.placeholders.status.disabled': 'inactiv',
  'people.notifications.added': 'Persoană adaugată.',
  'people.notifications.updated': 'Persoană actualizată.',
  'people.notifications.removed': 'Persoană eliminată.',
  'invites.menu.title': 'Coduri invitație',
  'invites.actions.add': 'Adaugă invitație',
  'invites.actions.view': 'Vizualizează',
  'invites.actions.remove': 'Elimină',
  'invites.actions.save': 'Salvează',
  'invites.actions.edit': 'Editează',
  'invites.actions.download': 'Descarcă',
  'invites.columns.code': 'Cod',
  'invites.columns.pin': 'PIN',
  'invites.columns.people': 'Persoane',
  'invites.columns.actions': 'Acțiuni',
  'invites.actions.manage': 'Gestionează',
  'invites.placeholders.code': 'Ex. NHTD8S',
  'invites.placeholders.pin': 'Ex. 8352',
  'invites.pages.edit.title': 'Detalii invitație',
  'invites.notifications.added': 'Invitație adaugată.',
  'invites.notifications.updated': 'Invitație actualizată.',
  'invites.notifications.removed': 'Invitație eliminată.',
  'settings.menu.title': 'Setări',
  'settings.menu.labels': 'Etichete',
  'settings.menu.rules': 'Reguli',
  'settings.menu.account': 'Cont',
  'settings.menu.account_edit': 'Editează cont',
  'settings.menu.account_create': 'Adaugă cont nou',
  'settings.rules.general': 'Regulă generală',
  'settings.rules.users': 'Reguli angajați',
  'settings.rules.car_class': 'Clasă',
  'settings.rules.limit': 'Limită',
  'settings.rules.actions.add': 'Adaugă regulă',
  'settings.rules.columns.id': 'ID',
  'settings.rules.columns.name': 'Nume',
  'settings.rules.columns.limit': 'Limită',
  'settings.rules.columns.car_class': 'Clasă',
  'settings.rules.columns.user': 'Angajat',
  'settings.rules.placeholders.name': 'Nume',
  'settings.rules.placeholders.limit': 'Limită',
  'settings.rules.placeholders.car_class': 'Clasă',
  'settings.labels.actions.add': 'Adaugă etichetă',
  'settings.labels.actions.view': 'Vizualizează',
  'settings.labels.actions.remove': 'Elimină',
  'settings.labels.actions.save': 'Salvează',
  'settings.labels.actions.edit': 'Editează',
  'settings.labels.columns.name': 'Nume',
  'settings.labels.columns.people': 'Angajați',
  'settings.labels.columns.actions': 'Acțiuni',
  'settings.labels.placeholders.name': 'Ex. Angajați',
  'settings.labels.pages.edit.title': 'Editează etichetă',
  'settings.labels.notifications.added': 'Etichetă adaugată.',
  'settings.labels.notifications.updated': 'Etichetă actualizată.',
  'settings.labels.notifications.removed': 'Etichetă eliminată.',

  'settings.account.sections.general': 'General',
  'settings.account.sections.legal': 'Informații legale',
  'settings.account.sections.bank': 'Informații bancare',
  'settings.account.sections.representative': 'Informații reprezentant',
  'settings.account.sections.location': 'Informații locatie',
  'settings.account.columns.name': 'Nume cont',
  'settings.account.columns.region': 'Regiune',
  'settings.account.columns.legal_name': 'Nume entitate legală',
  'settings.account.columns.legal_office_address': 'Adresă punct de lucru',
  'settings.account.columns.legal_address': 'Adresă sediu social',
  'settings.account.columns.legal_idno': 'Cod fiscal (CUI)',
  'settings.account.columns.legal_vat': 'Cod TVA',
  'settings.account.columns.legal_country': 'Țara',
  'settings.account.columns.bank_iban': 'IBAN',
  'settings.account.columns.bank_name': 'Nume bancă',
  'settings.account.columns.bank_code': 'Cod bancă',
  'settings.account.columns.bank_billing_address': 'Adresă bancă',
  'settings.account.columns.location_name': 'Adresa',
  'settings.account.columns.location_position': 'Locatie',
  'settings.account.columns.representative_name': 'Nume',
  'settings.account.columns.representative_position': 'Poziție',
  'settings.account.columns.representative_email': 'Adresă email',
  'settings.account.columns.representative_phone': 'Număr telefon',
  'settings.account.placeholders.name': 'ex. Mega Outlet Shop',
  'settings.account.placeholders.legal_name': 'ex. SC Mega Outlet Shop SRL',
  'settings.account.actions.create': 'Creează cont',
  'settings.account.actions.save': 'Actualizează',
  'settings.account.create.title': 'Creează un cont de companie',
  'settings.account.edit.title': 'Editează cont de companie',
  'settings.account.notifications.created': 'Cont creat.',
  'settings.account.notifications.updated': 'Cont actualizat.',
  'finance.menu.title': 'Financiar',
  'finance.menu.transactions': 'Tranzactii',
  'finance.menu.billing': 'Facturi',
  'billing.menu.title': 'Tranzactii',
  'billing.balance': 'Balanță',
  'billing.topup': 'Topup',
  'billing.balance_limit': 'Limită balanță',
  'billing.balance_limit_description':
    'Alimentează contul înainte să fie depășită această limită -  dacă balanța va fi negativă (mai jos de limită) prestarea serviciilor de taxi se vor suspenda automat.',
  'billing.filters.type': 'Toate tipurile',
  'billing.columns.type': 'Tip',
  'billing.columns.order': 'Comanda',
  'billing.columns.date_time': 'Data & Ora',
  'billing.columns.amount': 'Suma',
  'billing.topup.transaction_type': 'Tip',
  'billing.topup.card': 'Card',
  'billing.topup.cash': 'Cash',
  'billing.topup.amount': 'Suma',
  'billing.topup.description': 'Descriere',
  'cards.menu.title': 'Carduri',
  'cards.list': 'Carduri',
  'cards.add': 'Adauga card',
  'accounts.select_company': 'Selecteaza compania',
}

const ro = {
  locale: 'ro',
  antdData,
  messages,
}

export default ro
